<template>
  <div class="body">
    <div id="login">
      <div class="container">
        <div id="login-row" class="row justify-content-center align-items-center">
          <div id="login-column" class="col-md-4">
            <h2 class="text-center mt-5 text-white">招生報名後台管理</h2>
            <div id="login-box" class="col-md-12">
              <form id="login-form" class="form" action method="post">
                <div class="form-group">
                  <label for="username">人事代碼:</label>
                  <br />
                  <input
                    type="text"
                    name="username"
                    id="username"
                    v-model="id"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label for="password">密碼:</label>
                  <br />
                  <input
                    type="password"
                    name="password"
                    id="password"
                    v-model="password"
                    @keyup.enter ="onSubmit()"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <!-- <label for="remember-me">
                    <span>記住我的登入</span>
                    <span>
                      <input @keyup.enter ="onSubmit()" id="remember-me" name="remember-me" type="checkbox" />
                    </span>
                  </label>
                  <br /> -->
                  <input
                    type="button"
                    name="submit"
                    @click="onSubmit()"
                    class="btn btn-primary btn-md btn-block"
                    value="登入"
                  />
                  <p
                    class="text-danger text-center mt-1"
                    v-if="errorMessage !== ''"
                  >{{errorMessage}}</p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {loginAuth} from '../axios/api';

export default {
  data: function() {
    return {
      id: '',
      password: '',
      errorMessage: ''
    }
  },
  methods: {
    onSubmit: async function() {
      this.errorMessage = '';
      if (this.id === '' || this.password === '') {
        this.errorMessage = '請輸入帳號密碼';
      } else {
        // 登入作業
        await loginAuth({
          account: this.id,
          password: this.password,
        })
        .then(result => {
          if (result.token !== '' && result.result !== "FALSE") {
            // console.log(result);
            sessionStorage.setItem('token', result.token);
            this.$router.push('/dashboard/result');
          } else {
            this.errorMessage = '登入失敗';
          }
        })
        .catch(error => {
          this.errorMessage = '登入失敗';
          // console.log(error);
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.body {
  margin: 0;
  padding: 0;
  background-color: #17a2b8;
  height: 100vh;
}
#login .container #login-row #login-column #login-box {
  margin-top: 20px;
  max-width: 600px;
  // height: 320px;
  // border: 1px solid #9c9c9c;
  background-color: #ffffff;
}
#login .container #login-row #login-column #login-box #login-form {
  padding: 20px;
}
#login
  .container
  #login-row
  #login-column
  #login-box
  #login-form
  #register-link {
  margin-top: -85px;
}
#login-box {
  border-radius: 5px;
}
</style>